<template>
  <div class="home">
    <div style="   border: 1px solid;  overflow:hidden; width: 200px;
    margin: 40px auto; ">
    
                <VueSignaturePad
            id="signature"
            width="200px"
            height="450px"
            ref="signaturePad"
            
            :options="{ onBegin, onEnd }"
          />
            </div>
           <md-button  @click="clearPad()">Clear</md-button>
           <!-- <md-button class="md-raised md-primary" >
             <a download="signature.png" :href="imageData" style="color:white; text-decoration:none;">Download</a>
             </md-button> -->
           <md-button class="md-raised md-primary"  :disabled="emptyPad" @click="sendSign()">
            Send
             </md-button>
           
               <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Sign has been sent to the form!</md-dialog-title>

      

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false;$router.push('generate')">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
// import Vue from "vue";
export default {
  name: 'Sign',
  components: {
  },
  data(){
return {
  imageData:String,
  showDialog: false,
  emptyPad:true
}
  },
  computed:{

  },
  
  methods:{
        onBegin() {
      console.log('=== Begin ===');
      this.emptyPad=false;
      
    },
    onEnd() {
      console.log('=== End ===');
      this.imageData =this.$refs.signaturePad.saveSignature().data
    },
      clearPad(){
      this.$refs.signaturePad.clearSignature();
      this.emptyPad=true;
    },
    save(){
console.log(this.$refs.signaturePad.saveSignature().data)
    },
    sendSign(){
      var vm=this;
  var dataImg= this.$refs.signaturePad.saveSignature().data;



//  axios.post('http://localhost:3001/sign/api/send_img',{
//                   data: dataImg
//                 })
//       .then(response => { console.log(response)
//       });




//             const ws = new WebSocket("ws://localhost:9898/");
// const vm=this;
//         ws.onopen = function () {
//           console.log("WebSocket Client Connected");
//           ws.send(vm.$refs.signaturePad.saveSignature().data.toString());
//         };
//         ws.onmessage = function () {
 
//         };

axios;

// function rotateBase64Image(base64data, callback) 
    var canvas =document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    var image = new Image();
    image.src = dataImg;
    image.onload = function() {

    canvas.width =  image.height ;
    canvas.height =  image.width ;



      

 ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(90 * Math.PI / 180);
    ctx.drawImage(image, image.width / -2, image.height / -2);

        var rotatedDataImg= canvas.toDataURL();
              var ws = new WebSocket(((window.location.protocol == "https:")?'wss':'ws')+"://"+location.host+"/"+(process.env.VUE_APP_BASE_WEB || 'cartago-digital'));

          ws.onopen = function () {
            console.log("WS Connection opened");
              ws.send(rotatedDataImg);
vm.showDialog=true;
          };
    };





   

          // ws.onclose
        
    
    }
  }
}
</script>
